module.exports = {
          srcSet: __webpack_public_path__ + "private/eabd2996471d66cf8a0e111dcff9ebbd-3508.jpg"+" 3508w",
          images:[ {path: __webpack_public_path__ + "private/eabd2996471d66cf8a0e111dcff9ebbd-3508.jpg",width: 3508,height: 2480}],
          src: __webpack_public_path__ + "private/eabd2996471d66cf8a0e111dcff9ebbd-3508.jpg",
          toString:function(){return __webpack_public_path__ + "private/eabd2996471d66cf8a0e111dcff9ebbd-3508.jpg"},
          
          width: 3508,
          height: 2480
        }